import { Link } from 'react-router-dom';
import { events } from '@/mocks/events';
import EventCard from '@/components/feature/EventCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories } from '@/mocks/categories';

export default function TodayFocus() {
  const focus = [...events]
    .sort((a, b) => b.heat - a.heat)
    .slice(0, 4);

  const categoryName = (id: string) =>
    categories.find((cat) => cat.id === id)?.name ?? '';

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-12 bg-background-100">
      <SectionHeading
        eyebrow="Today Focus"
        title="今日焦点赛事"
        description="按热度排列的今日重点比赛，右侧黑5综合指数直观呈现赛事关注度与数据走势。"
        moreLabel="进入赛事分类"
        moreTo="/category/football"
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
        {focus.map((event) => (
          <EventCard key={event.id} event={event} categoryName={categoryName(event.categoryId)} />
        ))}
      </div>
      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/category/football"
          className="inline-flex items-center gap-1 text-sm text-primary-600"
        >
          进入赛事分类
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
        </Link>
      </div>
    </section>
  );
}